import { useEffect, useRef } from 'react';
import isEqual from 'lodash/isEqual';

import type {
	CollabPermissionEventPayload,
	CollabEditProvider,
} from '@atlaskit/editor-common/collab';

// This hook listens for permission changes and calls the onPermissionChange callback
export const useCollabPermissionChange = ({
	collabEditProvider,
	onPermissionChange,
}: {
	collabEditProvider: CollabEditProvider | null;
	onPermissionChange?: () => void;
}): void => {
	const permissionDataRef = useRef<CollabPermissionEventPayload | null>(null);

	useEffect(() => {
		if (!collabEditProvider) {
			return;
		}

		const handlePermissionChange = (permissionData: CollabPermissionEventPayload) => {
			if (
				permissionDataRef.current != null &&
				!isEqual(permissionDataRef.current, permissionData)
			) {
				// Passing the permission data to the callback would lead to a performance optimisation,
				// preventing refetching the permissions via a network request in LivePageComponent.
				onPermissionChange?.();
			}
			permissionDataRef.current = permissionData;
		};

		collabEditProvider.on('permission', handlePermissionChange);

		return () => {
			collabEditProvider.off('permission', handlePermissionChange);
		};
	}, [collabEditProvider, onPermissionChange]);
};
